import React from 'react';

const OrderTypeContext = React.createContext();

export const OrderTypeProvider = OrderTypeContext.Provider;
export const OrderTypeConsumer = OrderTypeContext.Consumer;
export default OrderTypeContext;